import React, {useEffect, useState} from 'react';
import {Spinner} from "reactstrap";
import {
    ADMIN_GET_STAKE_LEADERBOARD, ADMIN_GET_STAKE_MONTHS, HOMEPAGE_LEADERBOARDPRIZES_STAKE,
} from "../../../queries/queries";
import {useLazyQuery} from "@apollo/client";
import {number_format} from "../../../helpers";
import moment from "moment";
import * as XLSX from "xlsx";

const AdminStake = () => {

    const [leaderboardEntries, setLeaderboardEntries] = useState([]);
    const [leaderboardMonths, setLeaderboardMonths] = useState([]);
    const [leaderboardPrizes, setLeaderboardPrizes] = useState([]);

    const [activeMonth, setActiveMonth] = useState(moment().month() + 1);
    const [activeYear, setActiveYear] = useState(moment().year());

    const [loading, setLoading] = useState(false);

    const [getLeaderboardPrizes, {loadingPrize, refetchPrize}] = useLazyQuery(HOMEPAGE_LEADERBOARDPRIZES_STAKE, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardPrizes(e.getLeaderboardPrizesStake);
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const [getLeaderboardMonths] = useLazyQuery(ADMIN_GET_STAKE_MONTHS, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardMonths(e.getLeaderboardStakeMonths);
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const [getLeaderboard] = useLazyQuery(ADMIN_GET_STAKE_LEADERBOARD, {
        fetchPolicy: 'cache-and-network', onCompleted: (e) => {
            setLeaderboardEntries(e.adminGetLeaderboardStake);
            getLeaderboardPrizes();
        }, onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });

    const setActivePeriod = (month, year) => {
        setActiveMonth(month);
        setActiveYear(year);
        getLeaderboard({
            variables: {
                month: month, year: year
            }
        });
    }

    useEffect(() => {
        getLeaderboardMonths();
        getLeaderboard();
    }, []);

    const getRewardAtPosition = position => {
        return leaderboardPrizes[position] ? leaderboardPrizes[position].Reward : 0;
    };

    const doDownloadExcel = () => {
        const parsedExport = Object.assign({}, leaderboardEntries);

        for (const [index, item] of Object.entries(parsedExport)) {
            const {__typename, PlayerImage, ...rest} = item;
            parsedExport[index] = {...rest, Prize: getRewardAtPosition(index)};
        }

        const worksheet = XLSX.utils.json_to_sheet(Object.values(parsedExport));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Stake Leaderboard");
        XLSX.writeFile(workbook, `StakeLeaderboard_${activeYear}-${activeMonth}.xlsx`);
    }

    return (

        <div className="card text-bg-dark">
            <div className="card-header d-flex justify-content-between align-items-center">
                Stake
                <a onClick={doDownloadExcel} className="btn">Export</a>
            </div>

            <div className="card-body p-0">

                <div className="col-md-12 text-center mt-2 mb-2">
                    <div className="btn-group" role="group" aria-label="Basic example">
                        {leaderboardMonths.map(leaderboardMonth => <a
                            onClick={() => setActivePeriod(leaderboardMonth.Month, leaderboardMonth.Year)}
                            className={`btn btn-secondary ${activeYear == leaderboardMonth.Year && activeMonth == leaderboardMonth.Month ? 'active' : ''}`}>{leaderboardMonth.Month}/{leaderboardMonth.Year}</a>)}
                    </div>
                </div>

                <table className="table table-dark table-striped">
                    <thead>
                    <tr>
                        <th>
                            #
                        </th>
                        <th>
                            Player Name
                        </th>
                        <th>
                            Player ID
                        </th>
                        <th>
                            Wagered
                        </th>
                    </tr>
                    </thead>
                    {loading ? (<Spinner/>) : (<tbody>
                    {leaderboardEntries && leaderboardEntries.length > 0 ? (<>
                        {leaderboardEntries.map((row, index) => {
                            return (<tr key={index}>
                                <th scope="row">
                                    {index + 1}
                                </th>
                                <td>
                                    {row?.PlayerName}
                                </td>
                                <td>
                                    {row?.PlayerId}
                                </td>
                                <td>
                                    $ {number_format(row?.WageredAmount)}
                                </td>
                            </tr>);
                        })}
                    </>) : (<></>)}

                    </tbody>)}
                </table>

            </div>
        </div>);

};

export default AdminStake;